import { globalBigQueryReporter as _globalBigQueryReporter } from '@fiverr-private/identification_core';
import { BigQueryEventName, BigQueryEventsContext, AdditionalPropsMap } from './bigQuery.types';

const createBigQueryReporter = () => {
    const instance = _globalBigQueryReporter.extend<BigQueryEventName, BigQueryEventsContext, AdditionalPropsMap>({
        bigQueryPropertiesMap: {
            companySize: 'page.element.text',
            companyRole: 'page.element.text',
        },
    });

    instance.enrichContext(
        {
            group: 'identification flow',
            funnel: 'business',
            feature: { name: 'fiverr_business' },
        },
        {
            preserve: true,
        }
    );

    return instance;
};

export const globalBigQueryReporter = createBigQueryReporter();
